<template>
  <div>
    <v-container grid-list-xs text-xs-left pa0 class="c-top le-tbs-hide">
      <v-layout row wrap>
        <v-flex xs12 align-end class="c-m-bc">
          <v-breadcrumbs divider="/" :items="breadcrumbs">
            <template slot="item" slot-scope="props">
              <router-link
                v-if="props.item.link"
                v-ripple
                :to="{ name: props.item.link, params: { id: selectedCommunity.id } }"
                >{{ props.item.text }}</router-link
              >
              <template v-else>{{ props.item.text }}</template>
            </template>
          </v-breadcrumbs>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-lg text-xs-left pa0 class="c-top le-tbs-hide">
      <v-layout row wrap>
        <v-flex xs12 align-end class="c-subheader small">
          <v-subheader>{{ $T('page.member.invite.method.select.title') }}</v-subheader>
        </v-flex>
        <v-flex v-for="(type, idx) in createTypes" :key="type.id" xs6 align-end>
          <v-card
            raised
            ripple
            hover
            color="white"
            class="c-button c-light"
            @click.native="openDialog(idx)"
          >
            <div class="c-m-f">
              <div class="c-m-f-l">
                <v-avatar :size="60" color="green lighten-2">
                  <v-icon v-if="type.icon" :size="30" dark>{{ type.icon }}</v-icon>
                  <c-svg
                    v-else-if="type.svg == 'mark'"
                    id="icon-star"
                    width="32"
                    height="31"
                    t="mark"
                  ></c-svg>
                  <c-svg v-else id="icon-star" width="30" height="30" :t="type.svg"></c-svg>
                </v-avatar>
              </div>
              <div class="c-m-f-r">
                <div class="c-title">{{ type.title }}</div>
                <div class="c-explain">{{ type.explain }}</div>
              </div>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-list two-line class="c-sub-shadow c-space-sub">
      <v-subheader class="c-top-search">
        <div class="c-subheader first">
          <div class="l">
            <div v-if="cmid != 0" class="c-top-chip">
              <v-chip small close v-model="cmid_chip">
                <v-avatar size="20" class="c-small-avatar">
                  <c-img :src="'/cover/cm/' + cmid" />
                </v-avatar>
                <span class="c-chip sm">{{ cmnickname }}</span>
              </v-chip>
            </div>
            <div v-if="cid != 0" class="c-top-chip">
              <v-chip small close v-model="cid_chip">
                <v-avatar size="20" class="c-small-avatar">
                  <c-img :src="getCommunityCoverPath(cid)" />
                </v-avatar>
                <span class="c-chip sm">{{ getCommunityName(cid) }}</span>
              </v-chip>
            </div>
          </div>
          <div class="r">
            <div class="c-tip-btn">
              <v-tooltip :top="!leTbS" :bottom="leTbS" class="c-fr">
                <v-btn
                  slot="activator"
                  outline
                  fab
                  small
                  dark
                  class="ss"
                  :color="includeInvalid ? 'primary' : 'grey'"
                  @click="includeInvalid = !includeInvalid"
                >
                  <v-icon>mdi-link-variant-off</v-icon>
                </v-btn>
                <span>{{ $T('page.member.invite.include.invalid') }}</span>
              </v-tooltip>
            </div>
            <div class="c-tip-btn">
              <v-tooltip :top="!leTbS" :bottom="leTbS" class="c-fr">
                <v-btn
                  slot="activator"
                  outline
                  fab
                  small
                  dark
                  class="ss"
                  :color="includeOtherUser ? 'primary' : 'grey'"
                  @click="includeOtherUser = !includeOtherUser"
                >
                  <v-icon>mdi-account-multiple</v-icon>
                </v-btn>
                <span>{{ $T('page.member.invite.include.other.created') }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </v-subheader>

      <v-subheader v-show="leTbS" class="c-top-list-space le-tbs-show"> </v-subheader>

      <v-subheader>
        <div class="c-subheader">
          <div class="l">{{ $T('page.member.invite.list.title') }}</div>
          <div class="r">
            <v-btn
              class="c-sub-btn c-invite le-tb-show"
              @click="selectTypeDialog = true"
              color="clr-btn"
              flat
              small
              ><v-icon size="16">mdi-wallet-membership</v-icon
              >{{ $T('community_invitation.do') }}</v-btn
            >
          </div>
        </div>
      </v-subheader>

      <template v-for="(link, index) in list">
        <!-- issue#30: 一覧上で招待QR/リンクにタグを付与（リンクの上）。説明は表示しない。使用不可リンクは編集不可 -->
        <div
          v-if="link.type == 0 && (isActive(link) || link.currentTag)"
          :key="'tag-' + link.id"
          class="c-link-tag"
        >
          <div v-if="link.tagEditing && isActive(link)" class="c-tag-input">
            <v-text-field
              v-model="link.tagInput"
              :placeholder="$T('page.member.invite.tag.placeholder')"
              maxlength="20"
              counter="20"
              color="clr-primary"
              single-line
              hide-details
              class="c-tag-field"
              @keyup.enter="applyLinkTag(link)"
            ></v-text-field>
            <v-btn
              color="clr-btn"
              flat
              small
              :loading="link.tagLoading"
              :disabled="link.tagLoading"
              @click.stop.prevent="applyLinkTag(link)"
              >{{ $T('button.ok') }}</v-btn
            >
          </div>
          <div v-else>
            <v-chip
              v-if="link.currentTag"
              small
              color="clr-primary"
              text-color="white"
              class="c-tag-chip"
              :class="{ 'c-hand': isActive(link) }"
              @click.native="isActive(link) && startEditLinkTag(link)"
            >
              <v-icon left small>mdi-tag</v-icon>{{ link.currentTag }}
            </v-chip>
            <v-chip
              v-else-if="isActive(link)"
              small
              outline
              color="grey"
              class="c-tag-add-chip c-hand"
              @click.native="startEditLinkTag(link)"
            >
              <v-icon left small>mdi-tag-outline</v-icon>{{ $T('page.member.invite.tag.add') }}
            </v-chip>
          </div>
          <div v-if="link.tagError" class="c-tag-err">{{ link.tagError }}</div>
        </div>
        <v-list-tile :key="link.id" :class="'c-click c-click-' + link.id">
          <v-list-tile-content class="c-link-area">
            <v-list-tile-title :class="{ 'c-dis': !isActive(link) }">
              <v-tooltip top v-if="link.type == 0 && isActive(link)">
                <a
                  slot="activator"
                  :href="getInvitationLink(link.code, userLang)"
                  class="c-link custom-tooltip"
                  v-clipboard:copy="getInvitationLink(link.code, userLang)"
                  v-clipboard:success="onCopy"
                  @click.stop.prevent=""
                  >{{ getInvitationLink(link.code)
                  }}<span class="tooltiptext">{{
                    $T('community_invitation.click_to_copy')
                  }}</span></a
                >
                <span>{{ $T('community_invitation.click_to_copy') }}</span>
              </v-tooltip>
              <div class="c-link" v-else>
                <span v-if="link.type == 0">{{ getInvitationLink(link.code) }}</span>
                <span v-else-if="link.type == 1"
                  >( {{ $T('page.member.invite.mail.count', { count: link.invite_count }) }} )</span
                >
                <span v-else-if="link.type == 2"
                  >(
                  {{ $T('page.member.invite.from_com.count', { count: link.invite_count }) }}
                  )</span
                >
                <span v-else>-</span>
              </div>
            </v-list-tile-title>
            <v-spacer></v-spacer>
            <v-list-tile-sub-title>
              <div class="c-tm">
                <v-icon>mdi-pencil</v-icon>{{ utcToLocalMin(link.created_at) }}
              </div>
              <template v-if="!!link.completed_at">
                <div class="c-tm c">
                  <v-icon color="clr-primary">mdi-check-outline</v-icon
                  >{{ unixToMin(link.completed_at) }}
                </div>
              </template>
              <template v-else>
                <div :class="{ 'c-tm': true, b: isPast(link.expired), c: !!link.completed_at }">
                  <v-icon
                    :color="
                      link.completed_at ? 'clr-primary' : isPast(link.expired) ? 'danger' : ''
                    "
                    >mdi-timer-sand-empty</v-icon
                  >{{ unixToMin(link.expired) }}
                </div>
              </template>
              <div class="c-tm b" v-if="link.disabled_at">
                <v-icon :color="link.disabled_at ? 'danger' : ''">mdi-link-variant-off</v-icon
                >{{ unixToMin(link.disabled_at) }}
              </div>
            </v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <div class="c-action">
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  :disabled="link.type != 0 || !isActive(link)"
                  flat
                  icon
                  small
                  color="clr-primary"
                  v-clipboard:copy="getInvitationLink(link.code, userLang)"
                  v-clipboard:success="onCopy"
                  @click.stop.prevent=""
                  ><v-icon small>mdi-content-copy</v-icon></v-btn
                >
                <span>{{ $T('page.member.invite.created.link.button') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  :disabled="link.type != 0 || !isActive(link)"
                  flat
                  icon
                  small
                  color="clr-primary"
                  @click.native="
                    $refs.showQrDialog.openDialog(
                      link.id,
                      link.code,
                      link.expired,
                      false,
                      link.community_id || selectedCommunity.id,
                      link.currentTag,
                      link.originalCode,
                      link.taggedInviteId
                    )
                  "
                  ><v-icon small>mdi-qrcode</v-icon></v-btn
                >
                <span>{{ $T('page.member.invite.view.qr.title') }}</span>
              </v-tooltip>
              <v-tooltip v-if="!isPast(link.expired) && link.disabled_at && !link.completed_at" top>
                <v-btn
                  slot="activator"
                  flat
                  icon
                  small
                  color="clr-primary"
                  @click.native="openActivateConfirm(link.id)"
                  ><v-icon small>mdi-link-variant</v-icon></v-btn
                >
                <span>{{ $T('page.member.invite.activate.confirm.title') }}</span>
              </v-tooltip>
              <v-tooltip v-else top>
                <v-btn
                  slot="activator"
                  :disabled="!isActive(link)"
                  flat
                  icon
                  small
                  color="clr-danger"
                  @click.native="openDisactivateConfirm(link.id)"
                  ><v-icon small>mdi-link-variant-off</v-icon></v-btn
                >
                <span>{{ $T('page.member.invite.disactivate.confirm.title') }}</span>
              </v-tooltip>
            </div>
            <v-spacer></v-spacer>
            <div class="c-owner">
              <div v-if="includeOtherUserShow && !cmid_chip">
                <community-member-chip-s
                  :onlyicon="leTbS"
                  :cmid="link.community_member_id"
                  :cmname="link.nickname"
                  class="c-hand"
                  @click.native="
                    cmnickname = link.nickname
                    cmid = link.community_member_id
                  "
                  wCss="ss"
                />
              </div>
              <div v-if="allCommunityShow && !cid_chip">
                <community-chip-s
                  :onlyicon="leTbS"
                  :cid="link.community_id"
                  class="c-hand"
                  @click.native="cid = link.community_id"
                  wCss="ss"
                />
              </div>
            </div>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider v-if="index != list.length - 1"></v-divider>
      </template>

      <v-btn
        class="c-add-btn le-tbs-show"
        fab
        dark
        color="clr-btn"
        @click="selectTypeDialog = true"
        :disabled="selectTypeDialog"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>

      <v-dialog v-model="selectTypeDialog">
        <v-card class="c-select-dialog">
          <v-card-title class="c-dialog-title">
            <span>{{ $T('page.member.invite.method.select.title') }}</span>
            <v-spacer></v-spacer>
            <v-icon class="c-close" @click="selectTypeDialog = false">close</v-icon>
          </v-card-title>
          <v-container grid-list-lg text-xs-left>
            <v-layout column wrap>
              <v-flex
                v-for="(type, idx) in createTypes"
                :key="type.id"
                xs12
                align-end
                class="c-dlg-item"
              >
                <v-card
                  raised
                  ripple
                  hover
                  color="white"
                  class="c-button c-light"
                  @click.native="
                    openDialog(idx)
                    selectTypeDialog = false
                  "
                >
                  <div class="c-m-f">
                    <div class="c-m-f-l">
                      <v-avatar :size="35" color="green lighten-2">
                        <v-icon v-if="type.icon" :size="20" dark>{{ type.icon }}</v-icon>
                        <c-svg v-else id="icon-star" width="20" height="20" :t="type.svg"></c-svg>
                      </v-avatar>
                    </div>
                    <div class="c-m-f-r">
                      <div class="c-title">{{ type.title }}</div>
                    </div>
                  </div>
                  <div class="c-explain">{{ type.explain }}</div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="clr-btn-cancel" flat @click.native="selectTypeDialog = false">{{
              $T('button.close')
            }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <tail-loader v-if="filteredRecord" :srcs="filteredRecord" :unit="10" v-model="list" />
      <div v-if="filteredRecord.length == 0" class="c-nodata">
        {{ $T('common.no_data') }}
      </div>
    </v-list>

    <set-valid-period-dialog ref="setValidPeriodDialog" @invited="invited" />
    <set-mails-dialog ref="setMailsDialog" @invited="invited" />
    <invite-from-community-dialog ref="inviteFromCommunityDialog" @invited="invited" />
    <show-link-dialog ref="showLinkDialog" />
    <show-qr-dialog ref="showQrDialog" @tagchange="onDialogTagChange" />
    <confirm-dialog ref="confirmDialog" @ok="confirmOk" @cancel="confirmCancel" />
  </div>
</template>

<script>
import { COMMIN } from '../../constant'
import UTILS from '../../utils/utils'
import { communitySelect } from '../mixins/CommunitySelect'

import {
  changeInviteLinkActivation,
  getInviteLink,
  getInviteLinkAll,
  getProfileName,
  createTagToken,
} from '../../api/communityMember'
import setValidPeriodDialog from './SetValidPeriodDialog.vue'
import setMailsDialog from './SetMailsDialog.vue'
import inviteFromCommunityDialog from './InviteFromCommunityDialog.vue'
import showLinkDialog from './ShowLinkDialog.vue'
import showQrDialog from './ShowQrDialog.vue'

export default {
  beforeRouteEnter(route, redirect, next) {
    UTILS.startLoading()
    getInviteLink(route.params.id)
      .then(function (response) {
        UTILS.stopLoading()
        next((vm) => vm.setRecords(response))
      })
      .catch(function (error) {
        UTILS.stopLoading()
        console.error('failed to get member data', error)
        next(error)
      })
  },
  beforeRouteUpdate(to, from, next) {
    this.updateData(
      () => {
        next()
      },
      (e) => {
        next(e)
      }
    )
  },
  props: ['communityId'],
  components: {
    'set-valid-period-dialog': setValidPeriodDialog,
    'set-mails-dialog': setMailsDialog,
    'invite-from-community-dialog': inviteFromCommunityDialog,
    'show-link-dialog': showLinkDialog,
    'show-qr-dialog': showQrDialog,
  },
  data: function () {
    return {
      search: '',
      dataLoaded: false,
      breadcrumbs: [
        { text: $T('page.member.breadcrumbs.top'), link: 'topMember' },
        { text: $T('page.member.breadcrumbs.invite') },
      ],
      includeOtherUser: false,
      includeInvalid: false,
      inviteLinks: [],
      showConfirm: false,
      deleteInviteObj: null,
      includeOtherUserShow: false,
      allCommunityShow: false,
      cid: 0,
      cid_chip: false,
      cmid: 0,
      cmid_chip: false,
      cmnickname: null,
      selectTypeDialog: false,
      createTypes: [
        {
          icon: 'mdi-link-variant',
          title: $T('page.member.invite.method.link.title'),
          explain: $T('page.member.invite.method.link.explain'),
        },
        {
          icon: 'mdi-qrcode',
          title: $T('page.member.invite.method.qr.title'),
          explain: $T('page.member.invite.method.qr.explain'),
        },
        {
          svg: 'mail',
          title: $T('page.member.invite.method.mail.title'),
          explain: $T('page.member.invite.method.mail.explain'),
        },
        {
          svg: 'mark',
          title: $T('page.member.invite.method.community.title'),
          explain: $T('page.member.invite.method.community.explain'),
        },
      ],
      list: [],
    }
  },
  watch: {
    includeOtherUser(newVal, oldVal) {
      this.updateData()
    },
    includeInvalid(newVal, oldVal) {
      this.updateData()
    },
    cmid(newVal, oldVal) {
      if (newVal) {
        this.cid = 0
      }
      this.cmid_chip = newVal != 0
    },
    cmid_chip(newVal, oldVal) {
      if (!newVal) {
        this.cmid = 0
      }
    },
    cid(newVal, oldVal) {
      if (newVal) {
        this.cmid = 0
      }
      this.cid_chip = newVal != 0
    },
    cid_chip(newVal, oldVal) {
      if (!newVal) {
        this.cid = 0
      }
    },
  },
  computed: {
    filteredRecord() {
      if (!this.inviteLinks) return []
      if ((!this.cmid && !this.cid) || !this.inviteLinks || this.inviteLinks.length == 0) {
        return this.inviteLinks
      }
      return this.inviteLinks.filter((item) => {
        return (
          (this.cmid == 0 || item.community_member_id == this.cmid) &&
          (this.cid == 0 || item.community_id == this.cid)
        )
      })
    },
  },
  mixins: [communitySelect],
  methods: {
    isActive(item) {
      return !item.disabled_at && !this.isPast(item.expired) && !item.completed_at
    },
    changeCommunity(id) {
      this.cmid = 0
      this.$router.push({ name: 'changeCommunity', params: { id: id } })
    },
    updateData(success, fail) {
      var _this = this
      UTILS.startLoading()
      if (this.includeOtherUser) {
        getInviteLinkAll(this.selectedCommunity.id, this.includeInvalid)
          .then(function (response) {
            UTILS.stopLoading()
            _this.setRecords(response)
            success && success()
          })
          .catch(function (error) {
            UTILS.stopLoading()
            console.error('failed to get member data', error)
            fail && fail(error)
          })
      } else {
        getInviteLink(this.selectedCommunity.id, this.includeInvalid)
          .then(function (response) {
            UTILS.stopLoading()
            _this.setRecords(response)
            success && success()
          })
          .catch(function (error) {
            UTILS.stopLoading()
            console.error('failed to get member data', error)
            fail && fail(error)
          })
      }
    },
    setRecords(response) {
      if (this.selectedCommunity.id != 0) {
        this.allCommunityShow = false
      }
      if (!this.includeOtherUser) {
        this.includeOtherUserShow = false
      }
      this.cmnickname = null
      this.cmid = 0
      this.inviteLinks = response
      if (this.selectedCommunity.id == 0) {
        this.allCommunityShow = true
      }
      if (this.includeOtherUser) {
        this.includeOtherUserShow = true
      }
      if (this.inviteLinks && this.inviteLinks.length > 0 && this.selectedCommunity.should_invite) {
        this.resetShouldInviteMsg()
      }
    },
    invited(type, communityId, result) {
      if (this.selectedCommunity.id == 0 || this.selectedCommunity.id == communityId) {
        console.log('update')
        this.updateData()
      }
      console.log(this.selectedCommunity.id)
      console.log(communityId)

      if (type == 'link') {
        this.$refs.showLinkDialog.openDialog(result.id, result.code, result.expired)
        return
      }
      if (type == 'qr') {
        this.$refs.showQrDialog.openDialog(
          result.id,
          result.code,
          result.expired,
          true,
          communityId
        )
        return
      }
    },
    closeModal() {
      this.showModal = false
    },
    calcCommunityId() {
      return this.cid != 0 ? this.cid : this.selectedCommunity.id
    },
    openDialog(idx) {
      if (this.isGuest) {
        return this.shortMsg($T('common.guest_not_allowed'))
      }
      switch (idx) {
        case 0:
          return this.openSetValidPeriod('link', 10, 'd')
        case 1:
          return this.openSetValidPeriod('qr', 30, 'd')
        case 2:
          return this.openSetMails(10, 'd')
        case 3:
          return this.openInvite(10, 'd')
      }
      console.warn('UNKNOWN idx=' + idx)
    },
    openSetValidPeriod(type, expire, unit) {
      this.$refs.setValidPeriodDialog.openDialog(type, expire, unit, this.calcCommunityId())
    },
    openSetMails(expire, unit) {
      var _this = this
      getProfileName(this.selectedCommunity.id)
        .then(function (response) {
          _this.$refs.setMailsDialog.openDialog(
            response.name,
            expire,
            unit,
            _this.calcCommunityId()
          )
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    openInvite(expire, unit) {
      var _this = this
      this.$refs.inviteFromCommunityDialog.openDialog(expire, unit, this.calcCommunityId())
    },
    openActivateConfirm(id) {
      this.$refs.confirmDialog.openDialog(
        'activate',
        $T('page.member.invite.activate.confirm.title'),
        $T('page.member.invite.activate.confirm.msg'),
        id,
        true
      )
    },
    openDisactivateConfirm(id) {
      this.$refs.confirmDialog.openDialog(
        'disactivate',
        $T('page.member.invite.disactivate.confirm.title'),
        $T('page.member.invite.disactivate.confirm.msg'),
        id,
        true
      )
    },
    confirmOk(key, value) {
      if (key == 'disactivate' || key == 'activate') {
        var status = key == 'activate'
        var _this = this
        changeInviteLinkActivation(value, status)
          .then(function (response) {
            _this.$refs.confirmDialog.closeDialog()
            _this.inviteLinks.some(function (v, i) {
              if (v.id == value) v.disabled_at = status ? null : response
            })
          })
          .catch(function (error) {
            console.log(error)
            _this.$refs.confirmDialog.setErrMsg()
          })
        return
      }
      console.error('unknown key [' + key + ']')
    },
    confirmCancel(key, value) {
      this.$refs.confirmDialog.closeDialog()
    },
    onCopy(e) {
      this.shortMsg($T('common.copy.link.succeed'))
    },
    // issue#30: 一覧でのインラインタグ編集を開始（既存タグはプリフィル）
    startEditLinkTag(link) {
      if (link.originalCode == null) this.$set(link, 'originalCode', link.code)
      this.$set(link, 'tagInput', link.currentTag || '')
      this.$set(link, 'tagError', '')
      this.$set(link, 'tagEditing', true)
    },
    // issue#30: 一覧でタグを確定。未入力ならタグなし（親 code へ復帰）、入力ありなら子トークンへ差し替え
    applyLinkTag(link) {
      var t = (link.tagInput || '').trim()
      this.$set(link, 'tagError', '')
      if (!t) {
        this.$set(link, 'currentTag', '')
        link.code = link.originalCode
        this.$set(link, 'taggedInviteId', null)
        this.$set(link, 'tagEditing', false)
        return
      }
      if (t.length > 20) {
        this.$set(link, 'tagError', $T('page.member.invite.tag.too_long'))
        return
      }
      var self = this
      this.$set(link, 'tagLoading', true)
      var data = new FormData()
      data.append('cid', link.community_id || this.selectedCommunity.id)
      data.append('parent_invite_id', link.id)
      data.append('tag', t)
      createTagToken(data)
        .then(function (res) {
          self.$set(link, 'tagLoading', false)
          // 子トークンの code に差し替え → 表示リンク/コピー/QR がタグ付きになる
          link.code = res.code
          self.$set(link, 'currentTag', t)
          self.$set(link, 'taggedInviteId', res.id)
          self.$set(link, 'tagEditing', false)
        })
        .catch(function (error) {
          self.$set(link, 'tagLoading', false)
          // 長さ超過(>20)は呼び出し前に弾き済み。ここに来るのは API 失敗（権限なし=403 等）→ 誤って「タグが長すぎ」と出さず汎用の失敗表示にする
          self.$set(link, 'tagError', $T('common.failed.register'))
          console.error('failed to create tag token', error)
        })
    },
    // QRダイアログ側でタグを変更したら一覧の該当行へ反映（双方向同期）
    onDialogTagChange(d) {
      var arrs = [this.list, this.inviteLinks]
      for (var arr of arrs) {
        if (!arr) continue
        for (var l of arr) {
          if (l.id == d.id) {
            if (l.originalCode == null) this.$set(l, 'originalCode', d.originalCode)
            l.code = d.code
            this.$set(l, 'currentTag', d.currentTag)
            this.$set(l, 'taggedInviteId', d.taggedInviteId)
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.container.c-top {
  padding: 0px;
}
.c-subheader.first {
  margin-top: 10px;
}
.c-m-bc {
  margin-left: 4px;
  margin-bottom: 5px;
}

.c-subheader {
  display: flex;
  align-items: center;
  width: 100%;
}
.c-subheader .l {
  flex-grow: 1;
}
.c-subheader .r {
  position: relative;
  flex-grow: 2;
  text-align: right !important;
}

.c-subheader .r .v-input {
  position: absolute;
  top: -16px;
  right: 0px;
}
.v-subheader {
  height: 41px;
  padding: 5px 16px 5px 16px;
}
.c-subheader.small {
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
  height: 45px;
}
.c-subheader.small .v-subheader {
  padding: 15px 6px 0px 16px;
  font-size: 16px;
}

.c-m-f {
  display: flex;
  padding: 12px;
  width: 100%;
}
.c-m-f div {
  padding: 5px;
}
.c-m-f-l {
  width: 70px;
}
.c-m-f-r {
  flex-grow: 1;
  width: calc(100% - 94px);
}
.c-m-f .c-title {
  padding-top: 0px;
  font-size: 16px;
}
.c-m-f .c-explain {
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.54);
  white-space: pre-wrap;
}

.v-chip.v-chip--small .v-chip__content {
  padding: 0 12px 0 0 !important;
}

.v-list {
  padding: 0px 0px 5px 0px;
}
.v-subheader {
  height: 41px;
  padding: 5px 16px 5px 16px;
}
.v-list--two-line .v-list__tile {
  height: 48px !important;
}

.c-btn {
  border: 1px solid #666666;
  border-radius: 3px;
  box-shadow: 0px 0px 3px #cccccc;
  height: 100%;
}
.c-btn.selected {
  transition: 0.5s;
  border: 1px solid #1b5e20;
  background-color: #e8f5e9;
}
.c-explain {
  font-size: 13px;
  color: #666666;
  white-space: pre-wrap;
}
.c-btn.selected .c-explain {
  transition: 0.5s;
  color: #303030;
}

.c-space-sub {
  margin-top: 45px;
  margin-bottom: 30px;
}
.v-list__tile__content {
  padding: 8px 0px !important;
}
.c-tm {
  float: left;
  margin-right: 10px;
  font-size: 12px;
}
.c-tm .v-icon {
  font-size: 14px !important;
}
.c-tm.c {
  color: #388e3c !important;
}
.c-tm.b {
  color: #e64a19;
}
#icon-star {
  color: #fff;
}

.c-action {
  margin-top: -3px;
}
.c-action .v-btn {
  margin-right: 2px;
}
.c-owner {
  display: flex;
  margin-bottom: -4px;
}
/* issue#30: 一覧のインラインタグ */
.c-link-tag {
  padding: 6px 16px 0 16px;
  margin-bottom: -4px;
}
.c-link-tag .c-tag-input {
  display: flex;
  align-items: center;
  max-width: 360px;
}
.c-link-tag .c-tag-field {
  margin-top: 0;
  padding-top: 0;
}
.c-link-tag .c-tag-add-chip {
  color: rgba(0, 0, 0, 0.55) !important;
}
.c-link-tag .c-tag-add-chip .v-icon {
  color: rgba(0, 0, 0, 0.45) !important;
}
.c-link-tag .c-hand {
  cursor: pointer;
}
.c-link-tag .c-tag-err {
  color: #e64a19;
  font-size: 12px;
  margin-top: 2px;
}
.c-set {
  display: flex;
}
.c-top-chip {
  margin-top: 6px;
  margin-right: 2px;
}

.c-sub-btn {
  padding: 0;
  margin: 0;
  font-size: 13px;
  font-size: 13px;
  float: right;
}
.c-invite i {
  width: 20px;
}

.le-tbs .c-space-sub {
  margin: 0;
}
.le-tbs .c-link-area {
  width: calc(100vw - 130px);
  min-width: 190px;
}
.le-tbs .c-link {
  width: calc(100vw - 130px);
  min-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.c-add-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 76px;
  z-index: 30;
}
.c-select-dialog .container {
  margin-top: -15px;
  padding: 0 16px;
}
.c-select-dialog .c-m-f {
  padding: 5px 8px 0 8px;
}
.c-select-dialog .c-m-f-l {
  width: 45px;
}
.c-select-dialog .c-m-f-r {
  display: flex;
  align-items: center;
  width: calc(100% - 61px);
}
.c-select-dialog .c-title {
  padding: 0;
}
.c-select-dialog .c-explain {
  padding: 4px 8px 10px 13px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.le-tbs .c-top-search {
  min-width: 320px;
  position: fixed;
  top: 48px;
  left: 0;
  width: 100vw;
  background-color: #fff;
  margin-bottom: 5px;
  height: 46px;
  z-index: 50;
  padding: 0 16px;
}
.c-tip-btn {
  padding-left: 10px;
}
.c-top-chip {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 6px 0 -5px;
}
.c-top-list-space {
  height: 46px;
}

@media all and (-ms-high-contrast: none) {
  .c-dlg-item:not(:target) {
    min-height: 150px;
  }
}
</style>
